export const CONSULT_STATUS = ['unassigned', 'in_review', 'in_progress', 'in_call', 'completed'];
